import React from "react";
import AdminGroupAccountCard from "./AdminGroupAccountCard";
import '../Styles/AdminGroupAccountCardList.scss';
import AdminGroupAccountReservationCard from "./AdminGroupAccountReservationCard";


const AdminGroupAccountReservationCardList = ({reservations}) => {
   console.log("Here's queried Account", reservations)
	return (
		<div className="AdminGroupAccountCardListLayout">
			{ reservations?.map((reservation) => <AdminGroupAccountReservationCard
         reservation={reservation}/>)}
		</div>	

	)
}

export default AdminGroupAccountReservationCardList;